<template>
  <div :class="b([color, {horizontal, [status]: status}])"
    @click='onClick'>
    <div class="icon">
      <icon v-if="icon" :name="icon" />
      <img v-if="iconsrc" :class="b('icon-image', {big, huge})" :src="iconsrc">
      <div v-if="dot" class="dot"></div>
      <div v-if="infotext" class="infotext">{{ infotext }}</div>
    </div>
    <div v-if="text" class="text">{{ text }}</div>
  </div>
</template>

<script>
import create from '../utils/create'
import RouterLink from '../mixins/router-link'
export default create({
  name: "icon-button",
  mixins: [RouterLink],
  props: {
    color: {
      type: String,
      default: 'grey'
    },
    status: String,  /*active, success, error, info, caution*/
    horizontal: Boolean,
    icon: String,
    iconsrc: String,
    big: Boolean,
    huge: Boolean,
    dot: Boolean,
    infotext: [String, Number],
    text: String
  },

  methods: {
    onClick (event) {
      this.$emit('click', event)
      this.routerLink()
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/icon-button/index.vue